module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="fmcy-countdown"></span>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/count-down/count-down.html
 ** module id = 884
 ** module chunks = 1 89 179
 **/